import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BreadcrumbService } from '../../../services/breadcrumb';
import { TranslatePipe } from 'src/app/core/pipes/translate.pipe';
import { ChartType } from './apex.model';
import { CookieService } from 'ngx-cookie-service';
import { TimezoneService } from 'src/app/services/timezone';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import moment from 'moment';
import { OverallReportsService } from 'src/app/core/services/overall-reports/overall-reports.service';
import { ApiService } from 'src/app/services/api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getStoreLocations } from 'src/app/shared/ui/locationstate/location.selectors';
import { AppAliasService } from 'src/app/core/services/app-alias.service';
import { ChangeDetectorRef } from '@angular/core';
import { topTransactions, topProducts, topTransactionsChart } from './data';
@Component({
  selector: 'overall-insights',
  templateUrl: './overall-insights.component.html',
  styleUrls: ['./overall-insights.component.scss'],
  providers: [TranslatePipe],
})

export class OverallInsightsComponent implements OnInit, AfterViewInit {

  restaurants: any = [
    {
      storeName: "Purple Turtle",
      grossSales: "$16,726.48",
      netSales: "$11,715.93",
      totalOrders: 95,
      totalTransactions: 121,
      totalRefunds: "$0.00",
      totalDiscounts: "$6,924.03",
      totalTax: "$5,010.55",
      totalTips: "$656.30",
      totalDeliveryFees: "$46.18"
    },
    {
      storeName: "Langar houz",
      grossSales: "$14,873.21",
      netSales: "$10,482.33",
      totalOrders: 100,
      totalTransactions: 130,
      totalRefunds: "$5.00",
      totalDiscounts: "$6,342.88",
      totalTax: "$4,892.34",
      totalTips: "$720.45",
      totalDeliveryFees: "$51.32"
    },
    {
      storeName: "ROS Mumbai",
      grossSales: "$19,562.47",
      netSales: "$14,263.18",
      totalOrders: 120,
      totalTransactions: 160,
      totalRefunds: "$15.00",
      totalDiscounts: "$8,732.11",
      totalTax: "$6,549.29",
      totalTips: "$842.17",
      totalDeliveryFees: "$63.44"
    },
    {
      storeName: "Savor Bistro",
      grossSales: "$22,315.78",
      netSales: "$16,732.99",
      totalOrders: 130,
      totalTransactions: 170,
      totalRefunds: "$8.00",
      totalDiscounts: "$9,873.21",
      totalTax: "$7,532.12",
      totalTips: "$926.34",
      totalDeliveryFees: "$72.48"
    },
    {
      storeName: "Crimson Table",
      grossSales: "$18,492.53",
      netSales: "$13,928.75",
      totalOrders: 115,
      totalTransactions: 148,
      totalRefunds: "$12.00",
      totalDiscounts: "$7,492.78",
      totalTax: "$5,748.64",
      totalTips: "$795.21",
      totalDeliveryFees: "$58.33"
    },
    {
      storeName: "Urban Palate",
      grossSales: "$16,214.67",
      netSales: "$11,873.45",
      totalOrders: 102,
      totalTransactions: 132,
      totalRefunds: "$3.00",
      totalDiscounts: "$6,853.22",
      totalTax: "$5,212.14",
      totalTips: "$712.56",
      totalDeliveryFees: "$49.78"
    },
    {
      storeName: "Harvest Grill",
      grossSales: "$21,948.12",
      netSales: "$15,732.56",
      totalOrders: 128,
      totalTransactions: 162,
      totalRefunds: "$20.00",
      totalDiscounts: "$9,438.21",
      totalTax: "$7,215.44",
      totalTips: "$883.19",
      totalDeliveryFees: "$69.15"
    },
    {
      storeName: "Savor Bistro",
      grossSales: "$23,715.67",
      netSales: "$17,432.48",
      totalOrders: 135,
      totalTransactions: 178,
      totalRefunds: "$7.00",
      totalDiscounts: "$10,283.19",
      totalTax: "$7,874.15",
      totalTips: "$952.88",
      totalDeliveryFees: "$74.22"
    },
    {
      storeName: "Velvet Vine",
      grossSales: "$19,872.45",
      netSales: "$14,532.88",
      totalOrders: 122,
      totalTransactions: 154,
      totalRefunds: "$9.00",
      totalDiscounts: "$8,993.19",
      totalTax: "$6,823.14",
      totalTips: "$832.19",
      totalDeliveryFees: "$61.39"
    },
    {
      storeName: "Olive Garden",
      grossSales: "$26,548.32",
      netSales: "$19,738.64",
      totalOrders: 140,
      totalTransactions: 185,
      totalRefunds: "$4.00",
      totalDiscounts: "$11,428.56",
      totalTax: "$8,723.49",
      totalTips: "$1,052.33",
      totalDeliveryFees: "$82.57"
    }
  ];

  breadcrumbItems= [
    {
      label: 'Overall Insights',
      active: true,
      url: "/overall-insights",
    },
  ];
  Timezone: any;
  merchantId: string | undefined | null = this.cookieService.get("merchantId");
  storeIdFixed: any = this.cookieService.get('storeId');

  netSalesChart: ChartType;
  totalOrdersAndTransactionsChart: ChartType;
  totalMetricsChart: ChartType;
  topTransactionsByTypeChart: ChartType;
  topProductsChart: ChartType;
  currency = this.cookieService.get('currency');

  netSaleLoader: boolean = false;
  totalOrdersAndTransactionsLoader: boolean = false;
  totalMetricsLoader: boolean = false;
  topTransactionsByTypeLoader: boolean = false;
  topProductsLoader: boolean = false
  summaryReportLoader: boolean = false;

  emptyNetSales: boolean = false;
  emptyTotalOrdersAndTransactions: boolean = false;
  emptyTotalMetrics: boolean = false;
  emptyTopTransactionsByType: boolean = false;
  emptyTopProducts: boolean = false;
  emptySummaryReport: boolean = false;

  selectDateoption: any = "Today";
  dateFilteroptions = [
    "Today",
    "Yesterday",
    "This Week",
    "This Month",
    "This Quarter",
    "Custom",
  ];

  prevSelectDateoption: any = "Yesterday";
  prevStartDate: any;
  prevEndDate: any;
  prevStartDateDisplay: any;
  prevEndDateDisplay: any;
  prevStartDateDisplayFormatted: any;
  prevEndDateDisplayFormatted: any;
  startDate: any;
  endDate: any;
  customEndDate: any;
  startDateDisplay: any;
  endDateDisplay: any;
  customEndDateDisplay: any;
  startDateDisplayFormatted: any;
  endDateDisplayFormatted: any;
  customDate: any = "";
  a1: any;
  a2: any;

  cardData: any = {}
  GLOBALURL: String
  headerToken = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') }
  httpOptions1 = { headers: new HttpHeaders(this.headerToken) };

  locations$: any;
  apexToolbar: any = {
    show: true,
    offsetX: 0,
    offsetY: 0,
    tools: {
      download: true,
      selection: true,
      zoom: true,
      zoomin: true,
      zoomout: true,
      pan: true,
      customIcons: []
    },
    export: {
      csv: {
        filename: undefined,
        columnDelimiter: ',',
        headerCategory: 'category',
        headerValue: 'value',
        categoryFormatter(x) {
          return new Date(x).toDateString()
        },
        valueFormatter(y) {
          return y
        }
      },
      svg: {
        filename: undefined,
      },
      png: {
        filename: undefined,
      }
    },
    autoSelected: 'zoom'
  };

  constructor(
    private BreadcrumbService: BreadcrumbService,
    private cookieService: CookieService,
    private timezoneService: TimezoneService,
    private authService: AuthenticationService,
    private overAllReportsService: OverallReportsService,
    private ApiService: ApiService,
    private http: HttpClient,
    private store: Store,
    private AppAliasService: AppAliasService,
    private cdr: ChangeDetectorRef,
  ) {
    this.AppAliasService.getValue().subscribe((data) => {
      this.store.select(getStoreLocations).subscribe((res) => {
        this.locations$ = res;
        console.log(res);
      });
    });

    this.Timezone = this.timezoneService.get();
    this.GLOBALURL = this.ApiService.getBaseURL();

    this.prevStartDate = this.Timezone().subtract(1, 'day').startOf('day');
    this.prevEndDate = this.Timezone().subtract(1, 'day').endOf('day');
    this.prevStartDateDisplay = this.prevStartDate.unix();
    this.prevEndDateDisplay = this.prevEndDate.unix();
    this.prevStartDateDisplayFormatted = this.Timezone
      .unix(this.prevStartDateDisplay)
      .format("MMM Do YY");
    this.prevEndDateDisplayFormatted = this.Timezone
      .unix(this.prevEndDateDisplay)
      .format("MMM Do YY");
    this.startDate = this.Timezone().startOf('day');
    this.endDate = this.Timezone().endOf('day');
    this.customEndDate = this.Timezone().endOf('day');
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    this.customEndDateDisplay = this.customEndDate.unix();
    this.startDateDisplayFormatted = this.Timezone
      .unix(this.startDateDisplay)
      .format("MMM D YYYY");
    this.endDateDisplayFormatted = this.Timezone
      .unix(this.endDateDisplay)
      .format("MMM D YYYY");
  }

  ngOnInit() {
    this.BreadcrumbService.setValue(this.breadcrumbItems);
    if (!this.currency) {
      this.currency = "$";
    }

    this.store.select(getStoreLocations).subscribe((res) => {
      this.locations$ = res;
    });

    this.getReports();
    // this.fetchData() // For testing only;
  }


  ngAfterViewInit(): void {
    window.dispatchEvent(new Event('resize'));
  }

  async selectedDate(event: any) {
    // this.showItemCountPP = 0
    // this.p = 1;
    let day = this.authService.getClosingDay();
    console.log("day", day);
    const value = {
      start: moment(this.a1),
      end: moment(this.a2)
    }

    this.startDate = value.start;
    this.endDate = value.end;

    var a = this.timezoneService.get()(this.endDate);
    var b = this.timezoneService.get()(this.startDate);
    var diff = a.diff(b, "days") + 1;

    console.log("diff", diff)
    // this.prevStartDate = this.timezoneService.get()(this.a1).add(1, "days").startOf("day");
    this.startDate = this.timezoneService.get()(this.a1).startOf("day");
    this.endDate = this.timezoneService.get()(this.a2).endOf("day");

    this.prevStartDate = this.timezoneService.get()(value.start).subtract(diff, "day").startOf("day");
    this.prevEndDate = this.timezoneService.get()(value.end).subtract(diff, "day").endOf("day");

    const nativeDate = new Date(this.a1);
    const nativeMonth = nativeDate.getMonth();
    const nativeDay = nativeDate.getDate();

    const startDateMonth = this.startDate.month();
    const startDateMonthDay = this.startDate.date();

    const equalMonth = startDateMonth === nativeMonth;
    const equalDay = startDateMonthDay === nativeDay;

    console.log("startDateMonth", startDateMonth, startDateMonthDay);
    console.log("nativeMonth", nativeMonth, nativeDay);

    if (!equalMonth || (equalMonth && !equalDay)) {
      console.log("IFFF")
      this.startDate = this.startDate.add(1, 'days');
      this.prevStartDate = this.prevStartDate.add(1, 'days');
      this.endDate = this.endDate.add(1, 'days');
      this.prevEndDate = this.prevEndDate.add(1, 'days');
    }

    // this.prevEndDate = this.timezoneService.get()(this.a2).add(1, "days").endOf("day");
    this.prevStartDateDisplay = this.prevStartDate.unix();
    console.log("this.prevStartDateDisplay", this.prevStartDateDisplay)
    this.prevEndDateDisplay = this.prevEndDate.unix();
    console.log("this.prevEndDateDisplay", this.prevEndDateDisplay)
    this.prevStartDateDisplayFormatted = this.timezoneService.get()
      .unix(this.prevStartDateDisplay)
      .format("MMM D YYYY");
    this.prevEndDateDisplayFormatted = this.timezoneService.get()
      .unix(this.prevEndDateDisplay)
      .format("MMM D YYYY");
    this.prevSelectDateoption =
      this.prevStartDateDisplayFormatted +
      " to " +
      this.prevEndDateDisplayFormatted;

      // this.startDate = this.timezoneService.get()(this.a1).add(1, "days").startOf("day");
    if (day === 'Same Day') {
      // this.startDate = this.startDate.add(1, 'days');
      // this.endDate = this.endDate.add(1, 'days');
    }
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    this.startDateDisplayFormatted = this.timezoneService.get()
      .unix(this.startDateDisplay)
      .format("MMM D YYYY");
    this.endDateDisplayFormatted = this.timezoneService.get()
      .unix(this.endDateDisplay)
      .format("MMM D YYYY");
    this.selectDateoption = "custom";
    this.customDate =
      this.startDateDisplayFormatted + " to " + this.endDateDisplayFormatted;

    await this.getReports();
  }

  async selectedDateOption(type) {
    this.selectDateoption = type;
    if (type === "This Month") {
      this.prevSelectDateoption = "Last Month";
      this.prevStartDate = this.Timezone().subtract(1, "months").startOf("month");
      this.prevEndDate = this.Timezone().subtract(1, "months").endOf("month");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.Timezone
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.Timezone
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.Timezone().startOf("month");
      this.endDate = this.Timezone().endOf("month");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.Timezone
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.Timezone
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");

      this.getReports();
    } else if (type === "Last Month") {
      this.prevSelectDateoption = "Month before last month";
      this.prevStartDate = this.Timezone().subtract(2, "months").startOf("month");
      this.prevEndDate = this.Timezone().subtract(2, "months").endOf("month");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.Timezone
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.Timezone
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.Timezone().subtract(1, "months").startOf("month");
      this.endDate = this.Timezone().subtract(1, "months").endOf("month");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.Timezone
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.Timezone
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");

      this.getReports();
    }else if (type === "Yesterday"){
      this.prevSelectDateoption = "Day Before Yesterday";
      this.prevStartDate = this.Timezone().subtract(2, "days").startOf("day");
      this.prevEndDate = this.Timezone().subtract(2, "days").endOf("day");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.Timezone
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.Timezone
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.Timezone().subtract(1, "days").startOf("day");
      this.endDate = this.Timezone().subtract(1, "days").endOf("day");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.Timezone
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.Timezone
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");

      this.getReports();
    } else if (type === "Today") {
      this.prevSelectDateoption = "Yesterday";
      this.prevStartDate = this.Timezone().subtract(1, "days").startOf("day");
      this.prevEndDate = this.Timezone().subtract(1, "days").endOf("day");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.Timezone
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.Timezone
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.Timezone().startOf("day");
      this.endDate = this.Timezone().endOf("day");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.Timezone
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.Timezone
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");

      this.getReports();
    } else if (type === "This Week") {
      this.prevSelectDateoption = "Last Week";
      this.prevStartDate = this.Timezone().subtract(1, "week").startOf("week");
      this.prevEndDate = this.Timezone().subtract(1, "week").endOf("week");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.Timezone
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.Timezone
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.Timezone().startOf("week");
      this.endDate = this.Timezone().endOf("week");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.Timezone
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.Timezone
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");

      this.getReports();
    } else if (type === "This Quarter") {
      this.prevSelectDateoption = "Last Quarter";
      this.prevStartDate = this.Timezone().subtract(1, "quarter").startOf("quarter");
      this.prevEndDate = this.Timezone().subtract(1, "quarter").endOf("quarter");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.Timezone
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.Timezone
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.Timezone().quarter(this.Timezone().quarter()).startOf("quarter");
      this.endDate = this.Timezone().quarter(this.Timezone().quarter()).endOf("quarter");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.Timezone
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.Timezone
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");

      this.getReports();
    }
  }

  async getReports() {
    this.getNetSalesReport();
    this.getSummaryReport();
    this.getOrdersAndTransactionsReport();
    this.getMetrictsReport();
    this.getTopTransactionsByTypeReport();
    this.getTopProductsReport();

    this.getTotalReports();
  }

  getNetSalesReport() {
    this.netSaleLoader = true;
    const graphCurrency = this.currency;

    this.overAllReportsService.getNetSalesReport(
      this.merchantId,
      this.startDateDisplay,
      this.endDateDisplay
    ).subscribe((res: any) => {
        if (res?.intervals?.length) {
          this.emptyNetSales = false;
          res.intervals.map((interval) => interval.netSales)

          const netSalesChart = {
            chart: {
              height: 350,
              type: "bar",
              toolbar: {
                show: false
              },
              // toolbar: this.apexToolbar
            },
            plotOptions: {
              bar: {
                horizontal: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            series: [
              {
                name: "Amount",
                data: res.intervals.map((interval) => interval.netSales),
              },
            ],
            colors: ["#202020"],
            xaxis: {
              // tslint:disable-next-line: max-line-length
              // tickPlacement: "on",
              categories: res.intervals.map((interval) =>
                this.splitString(interval.storeName)
              ),
            },
            yaxis: {
              labels: {
                formatter: function (value) {
                  return `${graphCurrency}${value}`;
                },
              },
            },
            grid: {
              borderColor: "#f1f1f1",
            },
          };

          this.netSalesChart = netSalesChart;
          this.netSaleLoader = false;
        } else {
          this.emptyNetSales = true;
          this.netSaleLoader = false;
        }
      },
      (error) => {
        this.emptyNetSales = true;
        this.netSaleLoader = false;
      });
  }

  getOrdersAndTransactionsReport() {
    this.totalOrdersAndTransactionsLoader = true;

    this.overAllReportsService.getOrdersAndTransactions(
      this.merchantId,
      this.startDateDisplay,
      this.endDateDisplay
    ).subscribe((res: any) => {
        if (res?.data?.length) {
          this.emptyTotalOrdersAndTransactions = false;

          this.totalOrdersAndTransactionsChart = {
            chart: {
              height: 350,
              type: 'bar',
              toolbar: {
                show: false,
              },
              // toolbar: this.apexToolbar,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                endingShape: 'rounded',
                columnWidth: '45%',
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            colors: ['#34c38f', '#4682B4'],
            series: [{
              name: 'Total Orders',
              data: res.data.map((restaurant) => restaurant.totalOrders),

            }, {
              name: 'Total Transactions',
              data: res.data.map((restaurant) => restaurant.totalTransactions),
            }],
            xaxis: {
              // tickPlacement: "on",
              categories: res.data.map((restaurant) => this.splitString(restaurant.storeName)),
            },
            fill: {
              opacity: 1
            },
            grid: {
              borderColor: '#202020',
              padding: {
                left: 30,
              }
            },
            tooltip: {
              y: {
                formatter: (val) => {
                  return val;
                }
              }
            },
          };
          this.totalOrdersAndTransactionsLoader = false;
        } else {
          this.emptyTotalOrdersAndTransactions = true;
          this.totalOrdersAndTransactionsLoader = false;
        }
      },
      (error) => {
        this.emptyTotalOrdersAndTransactions = true;
        this.totalOrdersAndTransactionsLoader = false;
      });
  }


  getMetrictsReport() {
    this.totalMetricsLoader = true;
    const graphCurrency = this.currency;

    this.overAllReportsService.getMetrics(
      this.merchantId,
      this.startDateDisplay,
      this.endDateDisplay,
    ).subscribe((res) => {
      if (res?.data?.length) {
        this.totalMetricsChart = {
          chart: {
            height: 350,
            type: 'bar',
            toolbar: {
              show: false
            },
            // toolbar: this.apexToolbar,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: 'rounded',
              columnWidth: '45%',
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          colors: ['#FF6F61', '#34c38f', '#FFA07A', '#4682B4'],
          series: [
            {
              name: 'Total Refunds',
              data: res.data.map((restaurant) => restaurant.totalRefund),
            },
            {
              name: 'Total Discounts',
              data: res.data.map((restaurant) => restaurant.totalDiscount),
            },
            {
              name: 'Total Tax',
              data: res.data.map((restaurant) => restaurant.totalTax),
            },
            {
              name: 'Total Tips',
              data: res.data.map((restaurant) => restaurant.totalTip),
            },
          ],
          xaxis: {
            // tickPlacement: "on",
            categories: res.data.map((restaurant) => this.splitString(restaurant.storeName)),
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return `${graphCurrency}${value}`;
              }
            }
          },
          fill: {
            opacity: 1
          },
          grid: {
            borderColor: '#F1F1F1'
          },
          tooltip: {
            y: {
              formatter: (val) => {
                return `${graphCurrency}${val}`;
              }
            }
          }
        };
        this.emptyTotalMetrics = false;
        this.totalMetricsLoader = false;
      } else {
        this.emptyTotalMetrics = true;
        this.totalMetricsLoader = false;
      }
    },
    (error) => {
      this.emptyTotalMetrics = true;
      this.totalMetricsLoader = false;
    });
  }

  getTopTransactionsByTypeReport() {
    this.topTransactionsByTypeLoader = true;
    this.overAllReportsService.getTopTransactions(
      this.merchantId,
      this.startDateDisplay,
      this.endDateDisplay,
    ).subscribe((res) => {
        // const res: any = topTransactions;

        if (res?.error) {
          this.emptyTopTransactionsByType = true;
          this.topTransactionsByTypeLoader = false;
        } else {
          let series = this.formatTopTransactions(res);

          this.topTransactionsByTypeChart = {
            chart: {
              height: 350,
              type: "bar",
              stacked: true,
              toolbar: {
                show: false,
              }
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "15%",
                borderRadius: 3,
              }
            },
            series: series,
            title: {
              text: "Custom Data inserted into Series"
            },
            xaxis: {
              categories: res.map((restaurant) => this.splitString(restaurant.storeName)),
            },
            colors: [
              "#B3CDE0",
              "#6CA0DC",
              "#4682B4",
              "#2A4D77",
              "#1F2A44"
            ],
            tooltip: {
              x: {
              show: true,
              formatter: function(val, opt) {
                  var seriesIndex = opt.seriesIndex;
                  var dataPointIndex = opt.dataPointIndex;
                  return opt.w.config.series[seriesIndex].data[dataPointIndex]
                  .name;
              }
              },
              y: {
              title: {
                  formatter: function(seriesName, opt) {
                  var seriesIndex = opt.seriesIndex;
                  var dataPointIndex = opt.dataPointIndex;
                  return opt.w.config.series[seriesIndex].data[dataPointIndex].x + ":";
                  }
                }
              }
            },
            dataLabels: {
              enabled: false
            },
          };

          this.emptyTopTransactionsByType = false;
          this.topTransactionsByTypeLoader = false;
        }
      },
      (error) => {
        this.emptyTopTransactionsByType = true;
        this.topTransactionsByTypeLoader = false;
      });
  }

  getTopProductsReport() {
    this.topProductsLoader = true;

    this.overAllReportsService.getTopProducts(this.merchantId, this.startDateDisplay, this.endDateDisplay)
      .subscribe((response: any) => {
        // const response = topProducts;

        if (response?.error) {
          this.emptyTopProducts = true;
          this.topProductsLoader = false;
        } else {
          let series = this.formatTopProductsData(response);

          this.topProductsChart = {
            chart: {
              height: 350,
              type: "bar",
              stacked: true,
              toolbar: {
                show: false,
              }
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "15%",
                borderRadius: 3,
              }
            },
            series: series,
            colors: [
              "#D0F2E0",
              "#A4D5C2",
              "#74B49B",
              "#4A9C6C",
              "#1F6F4E"
            ],
            xaxis: {
              categories: response.map((restaurant) => this.splitString(restaurant.storeName)),
            },
            dataLabels: {
              enabled: false
            },
            grid: {
              borderColor: '#f1f1f1'
            },
            tooltip: {
              x: {
              show: true,
              formatter: function(val, opt) {
                  var seriesIndex = opt.seriesIndex;
                  var dataPointIndex = opt.dataPointIndex;
                  return opt.w.config.series[seriesIndex].data[dataPointIndex]
                  .name;
              }
              },
              y: {
              title: {
                  formatter: function(seriesName, opt) {
                  var seriesIndex = opt.seriesIndex;
                  var dataPointIndex = opt.dataPointIndex;
                  return opt.w.config.series[seriesIndex].data[dataPointIndex].x + ":";
                  }
                }
              }
            },
          };

          this.emptyTopProducts = false;
          this.topProductsLoader = false;
        }
      },
      (error) => {
        this.emptyTopProducts = true;
        this.topProductsLoader = false;
      });
  }

  formatTopProductsData(data) {
    const sortedRestaurants = data.sort((a, b) => b.topProduct.length - a.topProduct.length);
    let series = [
      {
          name: "Top 5",
          data: [],
      },
      {
          name: "Top 4",
          data: [],
      },
      {
          name: "Top 3",
          data: [],
      },
      {
          name: "Top 2",
          data: [],
      },
      {
          name: "Top 1",
          data: []
      }
    ];
    sortedRestaurants.forEach((res, index) => {
        if (res.topProduct.length > 0) {
          res.topProduct.reverse();
          res.topProduct.forEach((product, index) => {
              series[index].data.push({
                  x: product.type,
                  y: product.quantity,
                  name: res.storeName
              })
          });
        } else {
          for (let i = 0; i < 5; i++) {
            series[i].data.push({
              x: "N/A",
              y: 0,
              name: res.storeName
            });
          }
        }
    });

    return series;
  }

  formatTopTransactions(data) {
    console.log("DATA", data);
    const sortedRestaurants = data.sort((a, b) => b.topTransaction.length - a.topTransaction.length);
    let series = [
      {
          name: "Top 5",
          data: [],
      },
      {
          name: "Top 4",
          data: [],
      },
      {
          name: "Top 3",
          data: [],
      },
      {
          name: "Top 2",
          data: [],
      },
      {
          name: "Top 1",
          data: []
      }
    ];

    sortedRestaurants.forEach((res, index) => {
        if (res.topTransaction.length > 0) {
          res.topTransaction.reverse();
          res.topTransaction.forEach((product, index) => {
            series[index].data.push({
                x: product?.type,
                y: product?.quantity,
                name: res?.storeName
            })
          });
        } else {
          for (let i = 0; i < 5; i++) {
            series[i].data.push({
              x: "N/A",
              y: 0,
              name: res?.storeName
            });
          }
        }
    });

    return series;
  }

  getSummaryReport() {
    this.summaryReportLoader = true;

    this.overAllReportsService.getSummaryReport(
      this.merchantId,
      this.startDateDisplay,
      this.endDateDisplay
    ).subscribe((response) => {
      if (response.success && response.response.length > 0) {
        this.restaurants = response.response;
        this.summaryReportLoader = false;
        this.emptySummaryReport = false;
      } else {
        this.summaryReportLoader = false;
        this.emptySummaryReport = true;
      }
    },
    (error) => {
      this.emptySummaryReport = true;
      this.summaryReportLoader = false;
    });
  }

  changeStore(event:any) {
    this.storeIdFixed = event
    this.getTotalReports()
  }
  loader: Boolean = false;
  async getTotalReports() {

    console.log("Asd",this.startDateDisplay)
    let params = {
      "reportName": "home_stats_report",
      "query": {
        "startDate": this.startDateDisplay,
        "endDate": this.endDateDisplay,
        "lastStartDate": this.prevStartDateDisplay,
        "lastEndDate": this.prevEndDateDisplay,
        "merchantId": this.merchantId,
        "storeId": this.storeIdFixed
      }
    }
    this.loader = true
    console.log("HTTP OPTIONS 1", this.httpOptions1);
    return this.http.post(this.GLOBALURL + '/reports/query', params, this.httpOptions1).pipe(shareReplay(1)).subscribe((response: any) => {
      //console.log(response)
      if (!response.error) {
        this.cardData = response.data
        this.loader = false

      } else {
        //this.toastr.error(response.message)
        this.loader = false
      }
    }, (error) => {
      this.loader = false
      //this.toastr.success(error.message);
      //jQuery(".allpageLoader").css("display","none");
    });
  }
  checkNegative(num:any) {
    if (Math.sign(num) === -1) {
      return true;
    }

    return false;
  }
  checkZeroInc(num: any) {
    if (Math.abs(num) === 0) {
      return true
    }
    return false
  }
  showPlusData(num) {
    if(num)
    return '+'+ num
    else
    return '+0'
  }

  splitString(input) {
    // Check if input is a one-word string (no spaces)
    const isOneWord = input.indexOf(' ') === -1;
    // If it's a one-word string and its length is >= 15
    if (isOneWord && input.length >= 15) {
        const numSplits = Math.ceil(input.length / 15);
        let result = [];
        for (let i = 0; i < numSplits; i++) {
            result.push(input.slice(i * 15, (i + 1) * 15));
        }
        return result;
    }
    // If it's not a one-word string but its length is >= 15
    else if (!isOneWord && input.length >= 15) {
        return input.split(' ');
    }
    // If it's a short one-word string or a short multi-word string
    else {
        return [input];
    }
  }

  // Only for testing
  // private fetchData() {
  //   const graphCurrency = this.currency;

  //   this.getTotalReports();
  //   this.getSummaryReport();

  //   this.netSalesChart = {
	// 		chart: {
	// 				height: 350,
	// 				type: 'bar',
	// 				toolbar: {
	// 						show: false
	// 				}
	// 		},
	// 		plotOptions: {
	// 				bar: {
	// 						horizontal: false,
	// 				}
	// 		},
	// 		dataLabels: {
	// 				enabled: false
	// 		},
	// 		series: [{
	// 				name: "Amount",
	// 				data: [1800, 380, 450, 675, 850, 584, 780, 1500, 1020, 430]
	// 		}],
	// 		colors: ['#34c38f'],
	// 		xaxis: {
	// 				// tslint:disable-next-line: max-line-length
	// 				categories: [
	// 						"Purple Turtle",
	// 						"Langar houz",
	// 						"ROS Mumbai",
	// 						"Savor Bistro",
	// 						"Crimson Table",
	// 						"Urban Palate",
	// 						"Harvest Grill",
	// 						"Savor Bistro",
	// 						"Velvet Vine",
	// 						"Olive Garden"
	// 				],
	// 		},
	// 		yaxis: {
	// 				labels: {
	// 						formatter: function  (value) {
	// 								return `${graphCurrency}${parseInt(value)}`
	// 						}
	// 				}
	// 		},
	// 		grid: {
	// 				borderColor: '#f1f1f1'
	// 		},
  //   };

  //   this.totalOrdersAndTransactionsChart = {
  //     chart: {
  //       height: 350,
  //       type: 'bar',
  //       toolbar: {
  //           show: false
  //       }
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //         endingShape: 'rounded',
  //         columnWidth: '45%',
  //       },
  //     },
  //     dataLabels: {
  //       enabled: false
  //     },
  //     stroke: {
  //       show: true,
  //       width: 2,
  //       colors: ['transparent']
  //     },
  //     colors: ['#34c38f', '#4682B4'],
  //     series: [{
  //       name: 'Total Orders',
  //       data: [32, 158, 47, 112, 23, 184, 71, 95, 19, 205]
  //     }, {
  //       name: 'Total Transactions',
  //       data: [62, 139, 53, 125, 28, 192, 84, 76, 37, 215]
  //     }],
  //     xaxis: {
  //       categories: [
  //         "Purple Turtle",
  //         "Langar houz",
  //         "ROS Mumbai",
  //         "Savor Bistro",
  //         "Crimson Table",
  //         "Urban Palate",
  //         "Harvest Grill",
  //         "Savor Bistro",
  //         "Velvet Vine",
  //         "Olive Garden"
  //       ],
  //     },
  //     fill: {
  //       opacity: 1
  //     },
  //     grid: {
  //       borderColor: '#F1F1F1'
  //     },
  //     tooltip: {
  //       y: {
  //         formatter: (val) => {
  //           return val;
  //         }
  //       }
  //     }
  //   };

  //   this.totalMetricsChart = {
  //     chart: {
  //       height: 350,
  //       type: 'bar',
  //       toolbar: {
  //           show: false
  //       }
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //         endingShape: 'rounded',
  //         columnWidth: '45%',
  //       },
  //     },
  //     dataLabels: {
  //       enabled: false
  //     },
  //     stroke: {
  //       show: true,
  //       width: 2,
  //       colors: ['transparent']
  //     },
  //     colors: ['#FF6F61', '#34c38f', '#FFA07A', '#4682B4'],
  //     series: [
  //       {
  //         name: 'Total Refunds',
  //         data: [50, 75, 40, 90, 30, 85, 60, 70, 55, 100]
  //       },
  //       {
  //         name: 'Total Discounts',
  //         data: [120, 150, 110, 140, 100, 160, 130, 145, 115, 155]
  //       },
  //       {
  //         name: 'Total Tax',
  //         data: [80, 95, 85, 100, 75, 110, 90, 105, 70, 120]
  //       },
  //       {
  //         name: 'Total Tips',
  //         data: [70, 110, 65, 120, 55, 115, 80, 105, 50, 130]
  //       },
  //     ],
  //     xaxis: {
  //       categories: [
  //         "Purple Turtle",
  //         "Langar houz",
  //         "ROS Mumbai",
  //         "Savor Bistro",
  //         "Crimson Table",
  //         "Urban Palate",
  //         "Harvest Grill",
  //         "Savor Bistro",
  //         "Velvet Vine",
  //         "Olive Garden"
  //       ],
  //     },
  //     yaxis: {
  //       labels: {
  //         formatter: function (value) {
  //           return `${graphCurrency}${parseInt(value)}`;
  //         }
  //       }
  //     },
  //     fill: {
  //       opacity: 1
  //     },
  //     grid: {
  //       borderColor: '#F1F1F1'
  //     },
  //     tooltip: {
  //       y: {
  //         formatter: (val) => {
  //           return `${graphCurrency}${parseInt(val)}`;
  //         }
  //       }
  //     }
  //   };

  //   this.topTransactionsByTypeChart = {
  //     chart: {
  //       height: 350,
  //       type: "bar",
  //       stacked: true
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //         columnWidth: "15%",
  //         borderRadius: 3,
  //       }
  //     },
  //     series: [
  //       {
  //         name: "Top 5",
  //         data: [
  //           {
  //             x: "Amex",
  //             y: 10,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Doordash",
  //             y: 16,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "External CC",
  //             y: 11,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "eCard",
  //             y: 12,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "PostMates",
  //             y: 22,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "Givex",
  //             y: 32,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "BruinCard",
  //             y: 5,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "Voucherify",
  //             y: 18,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "GrubHub",
  //             y: 32,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "DoorDash",
  //             y: 29,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //       {
  //         name: "Top 4",
  //         data: [
  //           {
  //             x: "Blizzfull",
  //             y: 20,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Clover",
  //             y: 36,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "Cash",
  //             y: 28,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "Cryptocurrency",
  //             y: 21,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Visa",
  //             y: 29,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "MasterCard",
  //             y: 40,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "Card",
  //             y: 26,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "Digital Wallet",
  //             y: 20,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Card",
  //             y: 50,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "Cryptocurrency",
  //             y: 40,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //       {
  //         name: "Top 3",
  //         data: [
  //           {
  //             x: "Mastercard",
  //             y: 30,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Postmates",
  //             y: 51,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "UberEats",
  //             y: 38,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "Online",
  //             y: 60,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Cash",
  //             y: 48,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "Online",
  //             y: 51,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "Bank Transfer",
  //             y: 41,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "External CC",
  //             y: 36,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Clover",
  //             y: 62,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "Cash",
  //             y: 78,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //       {
  //         name: "Top 2",
  //         data: [
  //           {
  //               x: "Cash",
  //               y: 40,
  //               name: "Purple Turtle"
  //           },
  //           {
  //               x: "Account",
  //               y: 74,
  //               name: "Langar houz"
  //           },
  //           {
  //               x: "Discover",
  //               y: 68,
  //               name: "ROS Mumbai"
  //           },
  //           {
  //               x: "Cash",
  //               y: 81,
  //               name: "Savor Bistro"
  //           },
  //           {
  //               x: "Amex",
  //               y: 62,
  //               name: "Crimson Table"
  //           },
  //           {
  //               x: "GrubHub",
  //               y: 72,
  //               name: "Urban Palate"
  //           },
  //           {
  //             x: "Online",
  //             y: 65,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "External Cc",
  //             y: 58,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Clover",
  //             y: 78,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "Online",
  //             y: 90,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //       {
  //         name: "Top 1",
  //         data: [
  //           {
  //             x: "Card",
  //             y: 50,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Mastercard",
  //             y: 100,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "Visa",
  //             y: 84,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "Check",
  //             y: 113,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Gift Card",
  //             y: 125,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "Amex",
  //             y: 131,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "Cash",
  //             y: 95,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "Online",
  //             y: 76,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Bank Transfer",
  //             y: 105,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "eCard",
  //             y: 140,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //     ],
  //     title: {
  //       text: "Custom Data inserted into Series"
  //     },
  //     xaxis: {
  //       categories: [
  //         "Purple Turtle",
  //         "Langar houz",
  //         "ROS Mumbai",
  //         "Savor Bistro",
  //         "Crimson Table",
  //         "Urban Palate",
  //         "Harvest Grill",
  //         "Savor Bistro",
  //         "Velvet Vine",
  //         "Olive Garden"
  //       ]
  //     },
  //     colors: [
  //       "#B3CDE0",
  //       "#6CA0DC",
  //       "#4682B4",
  //       "#2A4D77",
  //       "#1F2A44"
  //     ],
  //     tooltip: {
  //       x: {
  //       show: true,
  //       formatter: function(val, opt) {
  //           var seriesIndex = opt.seriesIndex;
  //           var dataPointIndex = opt.dataPointIndex;
  //           return opt.w.config.series[seriesIndex].data[dataPointIndex]
  //           .name;
  //       }
  //       },
  //       y: {
  //       title: {
  //           formatter: function(seriesName, opt) {
  //           var seriesIndex = opt.seriesIndex;
  //           var dataPointIndex = opt.dataPointIndex;
  //           return opt.w.config.series[seriesIndex].data[dataPointIndex].x + ":";
  //           }
  //         }
  //       }
  //     },
  //     dataLabels: {
  //       enabled: false
  //     },
  //   };

  //   this.topProductsChart = {
  //     chart: {
  //       height: 350,
  //       type: "bar",
  //       stacked: true
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //         columnWidth: "15%",
  //         borderRadius: 3,
  //       }
  //     },
  //     series: [
  //       {
  //         name: "Top 5",
  //         data: [
  //           {
  //             x: "Hamburger",
  //             y: 19,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Pizza",
  //             y: 23,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "Pasta",
  //             y: 12,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "Steak",
  //             y: 18,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Salad",
  //             y: 33,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "Sandwich",
  //             y: 31,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "Soup",
  //             y: 14,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "Chicken",
  //             y: 40,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Fish",
  //             y: 19,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "Dessert",
  //             y: 52,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //       {
  //         name: "Top 4",
  //         data: [
  //           {
  //             x: "Cheeseburger",
  //             y: 21,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Margherita Pizza",
  //             y: 45,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "Lasagna",
  //             y: 29,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "Ribeye Steak",
  //             y: 32,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Caesar Salad",
  //             y: 51,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "Club Sandwich",
  //             y: 49,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "Tomato Soup",
  //             y: 23,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "Grilled Chicken",
  //             y: 46,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Salmon",
  //             y: 33,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "Chocolate Cake",
  //             y: 61,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //       {
  //         name: "Top 3",
  //         data: [
  //           {
  //             x: "BBQ Burger",
  //             y: 32,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Pepperoni Pizza",
  //             y: 51,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "Spaghetti",
  //             y: 33,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "Filet Mignon",
  //             y: 49,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Greek Salad",
  //             y: 62,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "Turkey Sandwich",
  //             y: 70,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "Chicken Noodle Soup",
  //             y: 84,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "Fried Chicken",
  //             y: 51,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Tuna",
  //             y: 57,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "Cheesecake",
  //             y: 71,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //       {
  //         name: "Top 2",
  //         data: [
  //           {
  //             x: "Double Cheeseburger",
  //             y: 59,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Mushroom Pizza",
  //             y: 73,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "Carbonara",
  //             y: 59,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "New York Strip Steak",
  //             y: 87,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Cobb Salad",
  //             y: 81,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "BLT Sandwich",
  //             y: 77,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "Lobster Bisque",
  //             y: 99,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "Grilled Chicken Caesar",
  //             y: 60,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Halibut",
  //             y: 84,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "Apple Pie",
  //             y: 73,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //       {
  //         name: "Top 1",
  //         data: [
  //           {
  //             x: "Gourmet Burger",
  //             y: 92,
  //             name: "Purple Turtle"
  //           },
  //           {
  //             x: "Supreme Pizza",
  //             y: 89,
  //             name: "Langar houz"
  //           },
  //           {
  //             x: "Ravioli",
  //             y: 65,
  //             name: "ROS Mumbai"
  //           },
  //           {
  //             x: "Porterhouse Steak",
  //             y: 112,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Caprese Salad",
  //             y: 90,
  //             name: "Crimson Table"
  //           },
  //           {
  //             x: "Turkey Club Sandwich",
  //             y: 85,
  //             name: "Urban Palate"
  //           },
  //           {
  //             x: "Minestrone Soup",
  //             y: 132,
  //             name: "Harvest Grill"
  //           },
  //           {
  //             x: "Lemon Herb Chicken",
  //             y: 85,
  //             name: "Savor Bistro"
  //           },
  //           {
  //             x: "Mahi Mahi",
  //             y: 91,
  //             name: "Velvet Vine"
  //           },
  //           {
  //             x: "Key Lime Pie",
  //             y: 156,
  //             name: "Olive Garden"
  //           },
  //         ]
  //       },
  //     ],
  //     title: {
  //       text: "Custom Data inserted into Series"
  //     },
  //     xaxis: {
  //       categories: [
  //         "Purple Turtle",
  //         "Langar houz",
  //         "ROS Mumbai",
  //         "Savor Bistro",
  //         "Crimson Table",
  //         "Urban Palate",
  //         "Harvest Grill",
  //         "Savor Bistro",
  //         "Velvet Vine",
  //         "Olive Garden"
  //       ]
  //     },
  //     colors: [
  //       "#D0F2E0",
  //       "#A4D5C2",
  //       "#74B49B",
  //       "#4A9C6C",
  //       "#1F6F4E"
  //     ],
  //     tooltip: {
  //       x: {
  //       show: true,
  //       formatter: function(val, opt) {
  //           var seriesIndex = opt.seriesIndex;
  //           var dataPointIndex = opt.dataPointIndex;
  //           return opt.w.config.series[seriesIndex].data[dataPointIndex]
  //           .name;
  //       }
  //       },
  //       y: {
  //       title: {
  //           formatter: function(seriesName, opt) {
  //           var seriesIndex = opt.seriesIndex;
  //           var dataPointIndex = opt.dataPointIndex;
  //           return opt.w.config.series[seriesIndex].data[dataPointIndex].x + ":";
  //           }
  //         }
  //       }
  //     },
  //     dataLabels: {
  //       enabled: false
  //     },
  //   };
  // }
}
